import { InstagramFeedPost } from '@anytag/graphql';
import { TableV2, TableV2Props } from '@anytag/shared-atoms';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerInstagramAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsInstagramPostsListTable } from './hooks';

export type AnalyticsInstagramPostsListProps = TableData<InstagramFeedPost> & {
  isComparePage?: boolean;
  tableRef?: TableV2Props<InstagramFeedPost>['reactTableRef'];
};

export const AnalyticsInstagramPostsList = ({
  loading,
  tableRef,
  data = [],
  isComparePage
}: AnalyticsInstagramPostsListProps) => {
  const { columns } = useAnalyticsInstagramPostsListTable({ isComparePage });

  return (
    <>
      <TableV2
        loading={loading}
        columns={columns}
        data={data}
        rowHeight="62px"
        reactTableRef={tableRef}
        noTopBorderRadius
        hasBorder
      />

      <InfluencerInstagramAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id) }))}
        isAnalytics
      />
    </>
  );
};
